module.exports = __webpack_public_path__ + "img/IMG_1626.88313cfa.jpg";